import { createContext, useContext, useEffect, useState } from "react";
import { useServer } from "./ServerContext";
import { useCookies } from "./CookiesContext";
import { cartEndpoints } from "../env";
import { useListener } from "react-bus";

const CartContext = createContext(undefined);

export const CartProvider = ({children}) => {
    //HOOKS
    const { getRequest, postRequest } = useServer();
    const { getCookie, setCookie } = useCookies();

    //STATES
    const [cart, setCart] = useState(null);
    const [cartLoading, setCartLoading] = useState(false);
    const [cartOpen, setCartOpen] = useState(false);
    const [finishOrderOpen, setFinishOrderOpen] = useState(false);

    //FUNCTIONS
    const loadCart = () => {
        if (cartLoading)
        {
            return;
        }

        setCartLoading(true);

        let data = {}
        let token = getCookie("cart_token");

        if (token != null)
        {
            data.cart_token = token;
        }

        getRequest(cartEndpoints.get_cart, data, (res) => {
            setCartLoading(false);
            if (res[0])
            {
                res = res[1];
                setCart(res.cart);
                setCookie("cart_token", res.cart.token);
            }
        });
    }

    const getCartToken = () => {
        return getCookie("cart_token");
    }

    const emptyCart = () => {
        setCartLoading(true);

        postRequest(cartEndpoints.empty_cart, {cart_token: getCartToken()}, (res) => {
            setCartLoading(false);
            if (res[0])
            {
                setCart(res[1].cart);
            }
        });
    }

    //EVENT LISTENERS
    useListener('cart_update', (newCart) => {
        setCart(newCart);
    });

    //EFFECTS
    useEffect(() => {
        loadCart();
    }, []);

    const value = {
        cart,
        setCart,
        loadCart,
        cartLoading,
        setCartLoading,
        getCartToken,
        cartOpen,
        setCartOpen,
        emptyCart,
        finishOrderOpen,
        setFinishOrderOpen
    }

    return (
        <CartContext.Provider value={value}>
            {children}
            
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
